export default function AircraftCard({aircraft, tags}) {
    
    const version = aircraft._version ? parseInt(aircraft._version) : 1
    const scheme = version === 3 && isObject(aircraft.class.image) ? aircraft.class.image.url : aircraft.class.image
    
    const getValue = (item) => {
        return version === 3 ? (item.label || item.value) : item;
    }

    const getUnits = (item) => {
        return version === 3 ? item.units : '';
    }
    
    const tagsFiltered = (tags || []).filter(e => e.value !== 'unviewed')

    return <div className="offer-modal__desc">
        <div className="offer-modal__top">
            <div>
                <h3 className="offer-modal__title">{aircraft.title}</h3>
                <div className="offer-modal__info">
                    {!!aircraft.year && <span>{aircraft.year}</span>}
                    <span>{aircraft.class.title}</span>
                </div>
                {tagsFiltered.length > 0 && <div className="offer-modal__tags">
                    {tagsFiltered.map(tag => <span key={`tags-${tag.label}`} >{tag.label}</span>)}
                </div>}
            </div>
            <div className="offer-modal__sheme">
                <img src={scheme} alt=""/>
            </div>
        </div>
        <div className="offer-modal__center">
            <ul className="offer-modal__list">
                <AircraftParameter title={__('search.amenity.catering')} value={getValue(aircraft.facilities.food)} />
                <AircraftParameter title={__('search.amenity.flightAttendant')} value={getValue(aircraft.facilities.stewardess)} />
                <AircraftParameter title={__('search.amenity.wifi')} value={getValue(aircraft.facilities.internet)} />
                <AircraftParameter title={__('search.amenity.lavatory')} value={getValue(aircraft.facilities.toilet)} />
                <AircraftParameter title={__('search.amenity.smoking')} value={getValue(aircraft.facilities.smoke)} />
                <AircraftParameter title={__('search.amenity.vipTerminal')} value={getValue(aircraft.facilities.vip)} />
            </ul>
            <ul className="offer-modal__list">
                <AircraftParameter title={__('search.aircraft.seats')} value={getValue(aircraft.params.seats)} />
                <AircraftParameter title={__('search.aircraft.cabinHeight')} value={getValue(aircraft.params.height)} unit={getUnits(aircraft.params.height)} />
                <AircraftParameter title={__('search.aircraft.cabinWidth')} value={getValue(aircraft.params.width)} unit={getUnits(aircraft.params.width)} />
                <AircraftParameter title={__('search.aircraft.cabinLength')} value={getValue(aircraft.params.length)} unit={getUnits(aircraft.params.length)} />
                <AircraftParameter title={__('search.aircraft.baggageVolume')} value={getValue(aircraft.params.trunk)} unit={getUnits(aircraft.params.trunk)} />
                {!!aircraft.update && <AircraftParameter title={__('search.aircraft.cabinRefurbishment')} value={getValue(aircraft.params.update_year)} unit={getUnits(aircraft.params.update_year)} />}
            </ul>
        </div>
    </div>
}

function AircraftParameter({ title, value, unit = '' }) {
    if (!value)
        return null
    
    const formattedValue = isNaN(parseFloat(String(value))) ? value : String(value).replace('.', ',')
    return <li>
        <span>{title}</span>
        <span dangerouslySetInnerHTML={{__html: `${formattedValue} ${unit}`}} />
    </li>
    
}

const isObject = (val) => {
    return typeof val === 'object' && val !== null && !Array.isArray(val);
}
